import { render } from "./KformNotice.vue?vue&type=template&id=893365ec&scoped=true"
import script from "./KformNotice.vue?vue&type=script&lang=js"
export * from "./KformNotice.vue?vue&type=script&lang=js"

import "./KformNotice.vue?vue&type=style&index=0&id=893365ec&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-893365ec"]])

export default __exports__